import {tagColors} from "@/components/tag/tag-colors";
export const InboundOrderEnum = {
  status: {
    WAIT_INBOUND: 'waitInbound',
    IN_INBOUND: 'inInbound',
    COMPLETED: 'completed'
  },
  statusOption: [
    {id: 'waitInbound', text: '待入库',...tagColors.orange},
    {id: 'inInbound', text: '入库中',...tagColors.blue},
    {id: 'completed', text: '已完成',...tagColors.green},
  ]
};
